tasks-delivered-calendar
  .line
    .cell-wrap(each="{cell in this.cells}")
      .cell(class="cell_{ cell.week } {today: cell.today}") &nbsp;
  .schedules
    tasks-delivered-cell(each="{id in opts.schedules}" tag-scope="schedule_{id}" base-date="{this.firstDate}")
  script(type="typescript").
    this.mixin('tasks.schedules-calendar')
  style(scoped).
    :scope {
      display: block;
      position: relative;
    }
    .schedules {
      position: absolute;
      top: 0;
      left: 0;
    }
